import type { TimeLogFieldsFragment } from '@/gql/time-tracking/graphql'

/**
 * Client-side exception detection (TT-V11 Phase 1, T01) — no BE "exception" field exists anywhere
 * in the schema (confirmed absent from `existing-be-api-surface.md`). Shared by Cycles' Exceptions
 * count (T06) and Needs Review/All Timesheets' Checks column (T08/T09): one implementation, not
 * three divergent ones.
 *
 * ## "Missing break" is deliberately NOT implemented here — a real, unresolved product decision,
 * not an oversight
 * The wireframe shows "Missing break" as exception text (verified live, My Time + Needs Review),
 * but its own `entiti_time_v11_feedback_validation.md` states this is explicitly **policy-driven**:
 * *"V11 records break evidence and asks for an exception reason when policy expects a break"* / it
 * *"should only activate when the effective jurisdiction/pay rule requires it"* — there is no
 * settled numeric threshold (e.g. "flag shifts over N hours with no break logged") anywhere in that
 * doc, and PLAN.md's non-goals explicitly rule a jurisdiction-aware policy/compliance rule engine
 * out of scope for this feature. Inventing a threshold here would be exactly the kind of
 * jurisdiction-specific rule this PRD is required to escalate, not guess (GOAL.md's Hard stop
 * conditions). Flagged to the orchestrator, confirmed correct (2026-09-20): not a gap to fill later
 * with a guessed number — implementing it now would mean inventing the exact threshold the
 * validation doc warns against.
 *
 * TODO(leave-policy domain): once `leave-policy`/the break-policy backend PLAN.md/GOAL.md defer for
 * this feature actually lands, add a real `requiredBreakMinutes`-driven "Missing break" check here.
 * Gated on that domain existing, not on remembering to revisit this file.
 */
export function detectTimeLogExceptions(log: TimeLogFieldsFragment): string[] {
  const exceptions: string[] = []
  if (log.type === 'OVERTIME') exceptions.push('Overtime')
  return exceptions
}
